import React, { useContext, useEffect, useState } from 'react';

import axios from 'axios';
import { toast } from 'react-toastify';
import { getError } from '../../../utils';

import Modal from 'react-bootstrap/Modal';
import { Form } from 'react-bootstrap';

import './css/login.css';

import AnimatedInput from './compoment/AnimatedInput';
import { Store } from '../../../Store';

const loginFields = [
  {
    key: 'old_password',
    name: 'Mật khẩu cũ',
    type: 'password',
    icon: 'ti ti-lock-filled',
    required: true,
    errorKey: 'old_password',
  },
  {
    key: 'new_password',
    name: 'Mật khẩu mới',
    type: 'password',
    icon: 'ti ti-lock',
    required: true,
    errorKey: 'new_password',
  },
  {
    key: 'confirm_password',
    name: 'Nhập lại mật khẩu',
    type: 'password',
    icon: 'ti ti-lock-password',
    required: true,
    errorKey: 'confirm_password',
  },
];

const initialForm = {
  old_password: '',
  new_password: '',
  confirm_password: '',
};

export default function ChangePassword(props) {
  const { state } = useContext(Store);
  const { userInfo } = state;

  const handleClose = () => {
    props.onHide();
  };

  const [formData, setFormData] = useState(initialForm);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (props.show) {
      setFormData(initialForm);
      setErrors({});
    }
  }, [props.show]);

  const submitHandler = async (e) => {
    e.preventDefault();

    try {
      const { data } = await axios.put('/user/change-password', formData, {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      });
      handleClose();
      toast.success(data.messages);
    } catch (err) {
      const messages = err.response?.data?.messages;
      if (err.response?.status === 422 && messages) {
        setErrors(messages);
      } else {
        toast.error(getError(err));
      }
    }
  };

  return (
    <div className="modal-login">
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
      >
        <Modal.Body>
          <button className="close close-color" onClick={handleClose}>
            <i className="fas fa-times"></i>
          </button>

          <section className="container-login ">
            <h2 className="text-center default-box-title">Cập nhật mật khẩu</h2>

            <Form onSubmit={submitHandler} className="modalOverideForm">
              {loginFields.map((field, idx) => (
                <div key={idx} className="mb-4 px-2">
                  <AnimatedInput
                    field={field}
                    value={formData[field.key]}
                    onChange={(e) =>
                      setFormData({ ...formData, [field.key]: e.target.value })
                    }
                    error={errors[field.errorKey]}
                  />
                  {field.key === 'new_password' && (
                    <aside className="note-pass">
                      <strong style={{ color: 'var(--red)' }}>Lưu ý: </strong>
                      Mật khẩu phải chứa ít nhất 8 ký tự, chữ hoa, chữ thường và
                      số.
                    </aside>
                  )}
                </div>
              ))}

              <div className="d-flex justify-content-end align-items-center mb-3">
                <button
                  className=" btn-info-close"
                  style={{ marginRight: '1rem' }}
                  onClick={handleClose}
                >
                  Hủy
                </button>
                <button type="submit" className="btn-edit">
                  Đổi mật khẩu
                </button>
              </div>
            </Form>
          </section>
        </Modal.Body>
      </Modal>
    </div>
  );
}
